import Links from '@component/navigation/links';

import I18n from '@module/i18n';
import LinkHelper from '@component/navigation/helpers/link';
import { userHasPlusTier, userHasFreeTier } from '@app/helper/user';

import LaunchDarkly from '@app/modules/launchdarkly/index';
import { FF_IMPLEMENT_SPACES } from '@app/constant/experiments';

const accountUser = (navigation, user, account) => {
  navigation = LinkHelper.attachAccountMenu(navigation, user);

  if (userHasPlusTier(user)) {
    navigation = LinkHelper.attachPlusMenu(navigation);

    // If user has sub domain
    if (account.subdomain_name) {
      navigation = LinkHelper.attachChannelName(
        navigation,
        account.subdomain_name
      );
    }

    // 2nd Plus Feature item
    if (LaunchDarkly.getVariant(FF_IMPLEMENT_SPACES)) {
      navigation = LinkHelper.attachFeatureSpacesLink(navigation);
    }

    // 1st Plus Feature item
    navigation = LinkHelper.attachReceivedTransfersLink(navigation);
  }

  if (userHasFreeTier(user)) {
    navigation = LinkHelper.attachUpgradeLink(navigation, 'desktop');
    navigation = LinkHelper.replaceProfileName(
      navigation,
      'navigation.home.name'
    );
  }
  return navigation;
};

const freeUser = (navigation) => {
  navigation = LinkHelper.attachSignupLink(navigation);

  return navigation;
};

export default {
  create: (user, account) => {
    let navigation = {
      help: Links.helpItem,
      about: {
        name: I18n.t('navigation.about_us.name_1_2019'),
        items: [Links.aboutItem, Links.productsItem, Links.advertiseItem],
      },
      account: Links.loginItem,
    };

    navigation = user.loggedIn
      ? accountUser(navigation, user, account)
      : freeUser(navigation);

    return Object.values(navigation);
  },
};
